import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-rewards-wallet-stamp',
  templateUrl: './empty-rewards-wallet-stamp.component.html',
  styleUrls: ['./empty-rewards-wallet-stamp.component.scss'],
})
export class EmptyRewardsWalletStampComponent  implements OnInit {
  @Input() mode:'button'
  constructor() { }

  ngOnInit() {}

}
